module.exports = __webpack_public_path__ + "static/media/ECTA.93310b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ECTA.jpg
// module id = 1730
// module chunks = 1